import {WorkOrder} from '../../@types/WorkOrder';
import {residentApiWithAuth} from '../../api/resident';
import {showErrorMessage} from '../../service/flashMessage';

export const addWorkOrder = async (workOrder: WorkOrder) => {
  try {
    const res = await residentApiWithAuth().post('/workorders', workOrder);
    const data = await res.data;
    if (data.errors) {
      const error = data.errors[0];
      throw new Error(error);
    }
    return await data.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateWorkOrder = async (id: string, workOrder: WorkOrder) => {
  try {
    const res = await residentApiWithAuth().post(
      `/workorders/${id}`,
      workOrder,
    );
    const data = await res.data;
    if (data.errors) {
      const error = data.errors[0];
      throw new Error(error);
    }
    return data.data;
  } catch (error) {
    const message = error?.response?.data.errors[0];
    throw new Error(message);
  }
};

export const fetchWorkOrders = async (
  pageNumber = 1,
  unitId: string,
  searchKey: string,
  pageSize = 10,
) => {
  try {
    let url = `/workorders?unitId=${unitId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

    if (searchKey) {
      url += `&searchKey=${searchKey}`;
    }

    const res = await residentApiWithAuth().get(url);
    const data = await res.data;
    if (data.errors) {
      const error = data.errors[0];
      throw new Error(error);
    }
    return data.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getListBySite = async (pageNumber = 1, siteId: string) => {
  try {
    let result = await residentApiWithAuth().get(`/listbysite/site/${siteId}`);
    return await result.data.data;
  } catch (error) {
    showErrorMessage(error.message);
  }
};

export const deleteMaintenanceById = async (id: string) => {
  try {
    return (await residentApiWithAuth().delete(`/workorders/${id}`)).data.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const fetchWorkOrdersPermissions = async (unitId: string) => {
  try {
    const res = await residentApiWithAuth().get(
      `/units/workOrdersPermissions/${unitId}`,
    );
    const data = res.data.data;
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};
